import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { LockStateService } from './lock-state.service';
import { BiometricService } from './biometric.service';

/**
 * Engages the biometric lock screen on native when a keystore-restored session
 * is opened after a cold start and the user has enabled biometric unlock.
 * No-op on web, when already unlocked this session, or when biometrics are off.
 */
export const biometricLockGuard: CanActivateFn = async (_route, state) => {
  if (!Capacitor.isNativePlatform()) {
    return true;
  }
  const lockState = inject(LockStateService);
  if (lockState.isUnlocked()) {
    return true;
  }
  const biometric = inject(BiometricService);
  if (!(await biometric.isEnabled())) {
    return true;
  }
  const router = inject(Router);
  return router.createUrlTree(['/lock'], { queryParams: { returnUrl: state.url } });
};
